import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../assets/styles/GlobalStyles';

// min-height fixo evita saltos visuais no layout enquanto o conteúdo real carrega
const SkeletonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
`;

const SkeletonCard = styled.div`
  background: ${colors.white};
  border-radius: 24px;
  padding: 2rem;
  width: 100%;
  max-width: 600px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
`;

const SkeletonLine = styled.div`
  height: ${props => props.height || '20px'};
  width: ${props => props.width || '100%'};
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%; 
  animation: loading 1.5s infinite;
  border-radius: 8px;       
  margin: ${props => props.margin || '0 0 1rem 0'};
  @keyframes loading {
    0% { background-position: 200% 0; }   
    100% { background-position: -200% 0; } 
  }
`;

const SkeletonAvatar = styled.div`
  width: 100px;
  height: 100px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 50%;
  margin: 0 auto 1rem;
`;

export const ProfileSkeleton = () => (
  <SkeletonContainer>
    <SkeletonCard>
      <SkeletonAvatar />
      <SkeletonLine width="60%" margin="0 auto 1rem auto" />
      <SkeletonLine width="40%" margin="0 auto 1rem auto" height="16px" />
      <SkeletonLine />
      <SkeletonLine width="90%" />
      <SkeletonLine width="80%" />
    </SkeletonCard>
  </SkeletonContainer>
);